module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 36-8ffaa27f70f09e79a0f4bdc02ee388bf.png";